<template>
  <div>
    <a-modal
      :title="'睡眠报告'"
      :visible="tan_gzList_show"
      :maskClosable="false"
      @cancel="tan_gzList_show = false"
      :dialog-style="{ 'min-width': '900px', 'max-width': '900px' }"
      :footer="null"
      id="viewBox"
    >
      <div class="needGZ_TanWrap" v-if="tan_gzList_show">
        <div class="needGZ_Tan">
          <div class="needGZ_Top" v-if="tan_gzList_nowSelWhat == 1">
            <div class="time">{{tan_gzList_topData.startDate | dataChange(tan_gzList_topData.startDate)}}</div>
            <div class="time2">&nbsp;/&nbsp;</div>
            <div class="time2">需要关注的老人</div>
            <div class="num" v-if="tan_gzList_topData.totleCount == 0">{{tan_gzList_topData.totleCount}}位</div>
            <div class="numRed" v-if="tan_gzList_topData.totleCount != 0">{{tan_gzList_topData.totleCount}}位</div>
            <div class="chazi" @click="tan_gzList_show = false">X</div>
          </div>
          <div class="needGZ_Top" v-if="tan_gzList_nowSelWhat == 7">
            <div class="time2">需要关注的老人</div>
            <div class="num" v-if="tan_gzList_topData.totleCount == 0">{{tan_gzList_topData.totleCount}}位</div>
            <div class="numRed" v-if="tan_gzList_topData.totleCount != 0">{{tan_gzList_topData.totleCount}}位</div>
            <div class="time3">{{tan_gzList_topData.startDate | dataChange(tan_gzList_topData.startDate)}}-{{tan_gzList_topData.endDate | dataChange(tan_gzList_topData.endDate)}}</div>
            <div class="chazi" @click="tan_gzList_show = false">X</div>
          </div>
          
          <div class="needGZ_Cont" style="padding-bottom:50px;">
            <div class="tabTime" v-if="tan_gzList_nowSelWhat == 1 || tan_gzList_nowSelWhat == 7">
              <div :class="['tabList',tan_gzList_nowSelWhat == 1 ? 'tabListSel' : '']" @click="cli_tan_gzList_type(1)">当日</div>
              <div :class="['tabList',tan_gzList_nowSelWhat == 7 ? 'tabListSel' : '']" @click="cli_tan_gzList_type(7)">最近7天</div>
            </div>

            <!-- 七天单独 -->
            <div class="policeWrap" v-if="tan_gzList_topData && tan_gzList_topData.moreDayRedioList && tan_gzList_nowSelWhat == 7">
              <div class="policeTit">{{tan_gzList_topData.moreDayRedioList.describe}}</div>
              <div id="tan_gzList_topEch" key="myChartsl19" style="height: 110px;"></div>
              <div class="poliProporte">需关注的老人比例</div>
            </div>

            

            <!-- 单日七天共用 -->
            <div class="oldPeople" v-if="tan_gzList_data && tan_gzList_data.records.length != 0">
              <div class="oldList">
                <div :key="index2" v-for="(item2,index2) in tan_gzList_data.records" @click="open_tan_needGZ_single(item2)">
                  <div class="oldList2" v-if="index2 < 7">
                    <img class="peoImg" src="../../../assets/home_icon_avatar_h@2x.png" alt="">
                    <div class="oldManName" v-if="tan_gzList_nowSelWhat == 1">{{ item2.buAndFlName }} · {{ item2.total }}项</div>
                    <div class="oldManName" v-if="tan_gzList_nowSelWhat == 7">{{ item2.buAndFlName }} · {{ item2.total }}天</div>
                  </div>
                </div>
              </div>
              <div class="oldList">
                <div :key="index2" v-for="(item2,index2) in tan_gzList_data.records" @click="open_tan_needGZ_single(item2)">
                  <div class="oldList2" v-if="index2 > 6 && index2 < 14">
                    <img class="peoImg" src="../../../assets/home_icon_avatar_h@2x.png" alt="">
                    <div class="oldManName" v-if="tan_gzList_nowSelWhat == 1">{{ item2.buAndFlName }} · {{ item2.total }}项</div>
                    <div class="oldManName" v-if="tan_gzList_nowSelWhat == 7">{{ item2.buAndFlName }} · {{ item2.total }}天</div>
                  </div>
                </div>
              </div>
              <div class="oldList">
                <div :key="index2" v-for="(item2,index2) in tan_gzList_data.records" @click="open_tan_needGZ_single(item2)">
                  <div class="oldList2" v-if="index2 > 13 && index2 < 21">
                    <img class="peoImg" src="../../../assets/home_icon_avatar_h@2x.png" alt="">
                    <div class="oldManName" v-if="tan_gzList_nowSelWhat == 1">{{ item2.buAndFlName }} · {{ item2.total }}项</div>
                    <div class="oldManName" v-if="tan_gzList_nowSelWhat == 7">{{ item2.buAndFlName }} · {{ item2.total }}天</div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
          <div v-if="tan_gzList_data" style="position:absolute;left: 50%;bottom: 30px;transform: translateX(-50%)">
            <a-pagination
              v-model="tan_gzList_pageNum"
              @change="tan_gzList_pageChange"
              :total="tan_gzList_data.total"
              :pageSize="tan_gzList_pageSize"
              :hideOnSinglePage="true"
              show-less-items
              style="text-align: center;"
            />
          </div>
        </div>
      </div>
    </a-modal>

    
    <!-- 弹窗_关注老人单人详情 -->
    <tan_needGz_sin ref="tan_needGz_sin"></tan_needGz_sin>
  </div>
</template>

<script>
import portFn from '../../../utils/PortraitFunction.js';
import dataJson from './bbb.json'
import tan_needGz_sin from './tan_needGz_sin.vue';      //弹窗_关注老人单人详情
export default {
  components: { tan_needGz_sin },
  filters: {
    dataChange(val){
      let newVal = val.slice(5,7) + '月' + val.slice(8,10) + '日'
      return newVal;
    },
  },
  props: {
    
  },
  watch: {
    
  },
  data() {
    return {
      // 弹窗_关注老人列表部分
      tan_gzList_show: false,
      tan_gzList_topData: null,   //弹窗_关注老人列表上方数据，其实和首页需关注老人是一样的接口防止和首页数据混乱
      tan_gzList_data: null,      //弹窗_关注老人列表数据
      tan_gzList_nowSelWhat: 1,   //弹窗_关注老人列表_当前选的什么 1单日 7七天
      tan_gzList_pageNum: 1,           
      tan_gzList_pageSize: 21,  
      tan_gzList_sortField: '',         //排序字段
      tan_gzList_sortOrder: 'ascend',   //顺序规则 正序-ascend，倒序-descend
    };
  },
  created() {},
  mounted() {
    
    
  },
  methods: {
    
    // 外界调用这个组件
    openComponent_tan_needGz_list_one_seven(data){
      console.log('调用了需关注列表1_7_____' + data.type)
      // this.tan_gzList_show = true;
      this.tan_gzList_nowSelWhat = data.type;

      this.$nextTick((res) =>{
        this.getNeedFollowTable()
      })
    },
    
    // 查看需要关注老人首页画图和数据展示
    getNeedFollowTable(){
      this.$get(
        'api/v4/home/getNeedFollowTable',
        {
          selectDateType: this.tan_gzList_nowSelWhat
        },
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.tan_gzList_show = true;
              this.tan_gzList_topData = res.data

              if(this.tan_gzList_nowSelWhat == 7){
                // 需要关注老人_七天
                let needFollow ={
                  xAxis: {
                    data: this.tan_gzList_topData.moreDayRedioList.dateList
                  },
                  series: {
                    data: this.tan_gzList_topData.moreDayRedioList.ratioList
                  }
                }
                this.$nextTick((res => {
                  this.getMyChart_optionLine('tan_gzList_topEch','seven_bjbl',needFollow);        //需关注老人_七天
                }))
                
              }
              this.$forceUpdate();
              this.getNeedFollowPageList()     //弹窗_关注老人列表_分页数据
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
        }
      );
    },
    
    // 弹窗_关注老人列表_分页数据
    getNeedFollowPageList(){
      this.$get(
        'api/v4/home/getNeedFollowPageList',
        {
          pageNum: this.tan_gzList_pageNum,
          pageSize: this.tan_gzList_pageSize,
          selectDateType: this.tan_gzList_nowSelWhat,    //取值:1, 7该参数不传默认为: 1
          sortField: this.tan_gzList_sortField,
          sortOrder: this.tan_gzList_sortOrder,     //顺序规则 正序-ascend，倒序-descend	
        },
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.tan_gzList_data = res.data

              // 临时假数据
              // let falseData = {
              //   'bedId': 23,
              //   'buAndFlName': '副书记啊迪卢克放暑假了开发机打撒',
              // }
              // for(let i = 0;i < 4;i++){
              //   this.tan_gzList_data.records.push(falseData)
              // }
              // 临时假数据end
              this.$forceUpdate()
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
        }
      );
    },
    // 弹窗_关注老人列表_分页
    tan_gzList_pageChange(e) {
      console.log(e);
      this.tan_gzList_pageNum = e;
      this.getNeedFollowPageList()
    },
    // 弹窗_关注老人列表_点击单日或七天
    cli_tan_gzList_type(type){
      this.tan_gzList_nowSelWhat = type;
      this.tan_gzList_pageNum = 1;
      this.tan_gzList_pageChange = 21;
      this.getNeedFollowTable();
    },


    
    // 点击关注老人中的某一个，出需关注单人详情
    open_tan_needGZ_single(data){
      let newData = data;
      newData.nowType = this.tan_gzList_nowSelWhat
      this.$refs.tan_needGz_sin.openComponent(newData)
    },



    
    // 公共折线图
    getMyChart_optionLine(idName, type, olddata) {
      let data = olddata
      // type  报警比例bjbl   弹窗_报警列表_报警比例_七天seven_bjbl   弹窗_睡眠整体情况查看异常tan_smAbn
      this.myChart_Line = this.$echarts.init(document.getElementById(idName));
      console.log(idName, type, data)

      let maxNum = Math.max(...data.series.data)
      let yAxis_max = Math.round(maxNum / 10) * 10 + 10
      
      
      let series_itemStyle_color = ['#1890FF','#1890FF']
      

      let grid_left = '0.5%'
      let grid_bottom = '1%'

      if(type == 'bjbl'){             //报警比例
        yAxis_max = null
        // data.xAxis.data = []
        grid_bottom = '4%'
      } else if(type == 'seven_bjbl'){
        yAxis_max = null
      } else if(type == 'tan_smAbn'){
        yAxis_max = null
      }
      var optionLine = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderColor: 'rgba(24, 144, 255, 0.6)',
          borderWidth: 1,
          spanStyle: {
            color: '#fff',
          },
          confine: true,
          borderRadius: 5,
          formatter: function(params) {
            console.log(type);
            console.log(params);
            if (type == 'bjbl') {      //报警比例
              return (
                // params[0].name +
                // '<br/>' +
                // '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
                // params[0].data + '%'


                params[0].name +
                '<br/>' +
                '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
                params[0].data + '%'
              );
            } else if(type == 'seven_bjbl' || type == 'tan_smAbn'){
              return (
                params[0].name +
                '<br/>' +
                '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
                params[0].data + '%'
              );
            }
          },
        },
        grid: {
          left: grid_left,
          // left: '0%',
          right: '0.5%',
          top: '15%',
          bottom: grid_bottom,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: data.xAxis.data,
            axisLabel: {
              // interval: 10,
              // spanStyle: {
              //   color: '', //坐标的字体颜色
              // },
              textStyle: {
                color: '#5E6779',
                fontSize:'10',
                itemSize:'',
              },
              show: type == 'bjbl' ? false : true
            },
            axisLine: {
              lineStyle: {
                color: '#9094A6',
              },
            },
            
            axisTick: {
              show: false,
              // alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            max: yAxis_max,
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#CACDD9'
              }
            },
            // minInterval: 1100, //设置最小间隔为1，防止出现小数
            minInterval: 1, //设置最小间隔为1，防止出现小数
            axisLabel: {
              // spanStyle: {
              //   color: '#5E6779', //坐标的字体颜色
              // },
              textStyle: {
                color: '#5E6779',
                fontSize:'10',
                itemSize:''
              }
            },
            axisLine: {
              lineStyle: {
                color: '#c7c6c9',
              },
              show: false,
            },
            splitNumber: 1,
          },
        ],
        series: [
          {
            data: data.series.data,
            type: 'line',
            barWidth: 20,
            // symbol: 'none',
            lineStyle:{           //线条颜色
              color:'#1890FF'
            },
            // smooth: true,         //平滑处理
            symbol: 'circle',
            showSymbol: type == 'bjbl' ? false : true,
            symbolSize: 8,
            color: '#1890FF',
            areaStyle: type == 'seven_bjbl' || type == 'tan_smAbn' ? {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(24, 144, 255, 0.4)', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(24, 144, 255, 0.05)', // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            } : null,
            markLine: type == 'tan_smAbn' ? {
              symbol: 'none',
              emphasis: {
                lineStyle: {
                  width: 1, // hover时的折线宽度
                },
              },
              data: [
                {
                  silent: false, //鼠标悬停事件  true没有，false有
                  lineStyle: {
                    //警戒线的样式  ，虚实  颜色
                    type: 'dashed',
                    color: '#63B2FB',
                  },
                  label: {
                    position: 'end',
                    formatter: '',
                  },
                  yAxis: data.avg, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                },
              ],
            } : null,
          }
          
        ]
      }
      this.myChart_Line.setOption(optionLine,true);
      window.addEventListener('resize', () => {
        this.myChart_Line.resize();
      });
      this.$forceUpdate()
    },
    








    
    
  },
};
</script>
<style lang="scss" scoped>
@import '../../../assets/css/comHome.scss';


</style>
